import { useState, useEffect, useRef } from 'react'
import { getQueueCount, processQueue, startAutoSync } from '../utils/offlineQueue'

export function useOfflineSync() {
  const [isOnline, setIsOnline] = useState(navigator.onLine)
  const [queueSize, setQueueSize] = useState(0)
  const [isSyncing, setIsSyncing] = useState(false)
  const mountedRef = useRef(true)

  useEffect(() => {
    mountedRef.current = true

    // Start auto-sync listener
    startAutoSync()

    // Update online status
    function handleOnline() {
      setIsOnline(true)
    }

    function handleOffline() {
      setIsOnline(false)
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    // Check queue size periodically
    updateQueueSize()
    const interval = setInterval(updateQueueSize, 5000)

    return () => {
      mountedRef.current = false
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
      clearInterval(interval)
    }
  }, [])

  async function updateQueueSize() {
    const count = await getQueueCount()
    if (mountedRef.current) {
      setQueueSize(count)
    }
  }

  async function syncNow() {
    if (!isOnline || isSyncing) return

    setIsSyncing(true)
    try {
      await processQueue()
      await updateQueueSize()
    } finally {
      setIsSyncing(false)
    }
  }

  return {
    isOnline,
    isOffline: !isOnline,
    queueSize,
    isSyncing,
    syncNow,
  }
}
